/**
 * Created by gorya on 06/09/2016.
 */
$(document).ready(function () {
    $('#cssmenu li.active').addClass('open');
    $('#cssmenu li.has-sub > span').on('click', function () {
        $(this).removeAttr('href');
        var element = $(this).parent('li');
        if (element.hasClass('open')) {
            element.removeClass('open');
            element.find('li').removeClass('open');
        } else {
            element.siblings('li').removeClass('open');
            element.addClass('open');
            element.siblings('li').find('li').removeClass('open');
        }
    });

    var wrapper = $('#wrapper');
    var toggle = $('#toggle-sidebar');
    var overlay = $('#wrapper .overlay');
    if (wrapper.length) {
        overlay.click(function () {
            toggle.removeClass('is-opened');
            wrapper.removeClass('toggled');
        });
        toggle.click(function () {
            var toggle = $(this);
            if (toggle.hasClass('is-opened')) {
                toggle.removeClass('is-opened');
                wrapper.removeClass('toggled');
            } else {
                toggle.addClass('is-opened');
                wrapper.addClass('toggled');
            }
        })
    } else {
        toggle.hide();
    }
});